module.exports = __webpack_public_path__ + "entry-150bfe9b/oetker-photo-31e4ca814f9ad6ccfed7fa0ef4648d12.webp";